import { render } from "./ErrorLayout.vue?vue&type=template&id=2de615dc&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"

import "./ErrorLayout.vue?vue&type=style&index=0&id=2de615dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de615dc"]])

export default __exports__